import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ValidationManager } from '@chegg/commerce-utils';
var CCFIELDS = ValidationManager.types.CCFIELDS;
export var transformLoadMopPayload = function transformLoadMopPayload(action, instance, selectedMop) {
  var month = selectedMop.month,
    year = selectedMop.year,
    billingAddress = selectedMop.billingAddress,
    type = selectedMop.type;
  if (billingAddress) {
    var fname = billingAddress.fname,
      lname = billingAddress.lname;
    return {
      payload: {
        instance: instance,
        formFields: _defineProperty(_defineProperty({}, CCFIELDS.CARDHOLDER_NAME, {
          value: "".concat(fname, " ").concat(lname),
          error: '',
          empty: false
        }), CCFIELDS.EXPIRATION_DATE, {
          value: "".concat(month, "/").concat(year),
          error: '',
          empty: false
        }),
        cardType: type
      }
    };
  } else {
    return {
      payload: _objectSpread({}, action.payload)
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/transformLoadMopPayload.js
// module id = 4395
// module chunks = 11